import { useMutation } from "@apollo/client";
import { AppContext } from "App";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import FactorySelector from "components/shared/FactorySelector";
import { ProductImagesV2 } from "components/shared/ProductImages";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CREATE_FINAL_REPORT } from "./graphql";

const CreateReport = ({
  product,
  qty,
  sourceType,
  sourceOdooId,
  sourceLineOdooId,
  sourceName,
  customerOdooId,
  invoiceId,
  onCreated,
}) => {
  const { user } = useContext(AppContext);
  const [packingFactoryId, setPackingFactoryId] = useState(
    user.email === "acro@waboba.com" ? "42" : product?.packingFactory?.id,
  );

  const navigate = useNavigate();
  const [createReport, createReportRes] = useMutation(CREATE_FINAL_REPORT, {
    onCompleted: (res) => {
      Alert("success", "QC Report 创建成功！");

      if (onCreated) onCreated();
      navigate(`/qc/reports/${res.createFinalReport.finalReport.id}`);
    },

    onError: (error) => Alert("error", error.message),

    refetchQueries: ["FETCH_QC_REPORTS_LIST"],
  });

  const images = product.computedImages;

  return (
    <div className="space-y-6 text-base">
      <div>
        <div className="flex flex-wrap">
          <ProductImagesV2 images={images} />
        </div>
        <div className="mt-3">
          {product.name}
          <span className="ml-3 font-bold"> &times; {qty}</span>
        </div>
      </div>

      <div className="flex items-center space-x-3">
        <label>Factory 包装工厂:</label>
        <div className="font-bold">
          {product?.packingFactory?.name || "N/A"}
        </div>
      </div>

      <Button
        next
        loading={createReportRes.loading}
        onClick={() =>
          createReport({
            variables: {
              factoryId: packingFactoryId,
              productId: product.id,
              qty: qty,
              sourceType,
              soOdooId: sourceType === "SO" ? sourceOdooId : null,
              soLineOdooId: sourceType === "SO" ? sourceLineOdooId || null : null,
              customerOdooId: customerOdooId || null,
              so: sourceType === "SO" ? sourceName : null,
              transferOdooId: sourceType === "TRANSFER" ? sourceOdooId : null,
              transferMoveOdooId: sourceType === "TRANSFER" ? sourceLineOdooId || null : null,
              transfer: sourceType === "TRANSFER" ? sourceName : null,
              invoiceId: invoiceId || null,
            },
          })
        }
      >
        Next 下一步
      </Button>
    </div>
  );
};

export default CreateReport;
